import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Newjob from './pages/jobs/Newjob';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './pages/Dashboard/DashboardLayout';
import { ToastContainer, toast,Bounce } from 'react-toastify';
import Permits from './pages/Permits/Permits';
import Register from './Register';
import Verify from './VerifyEmail';
import Forgot from './Forgot';
import PasswordReset from './PasswordReset';
import JobsPanel from './pages/jobs/JobsPanel';
function App() {
  return (
    <>

    
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />
         <Route path="/verify" element={<Verify />} />
            <Route path="/forgot-password" element={<PasswordReset />} />
      <Route path="/reset-password" element={<Forgot />} />
           
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
         <Route path="/dashboard/newjob" element={<Newjob />} />
        <Route path="/dashboard/permits" element={<Permits />} />
       <Route path="/dashboard/jobs/:id" element={<JobsPanel />} />

        
      </Route>
    </Routes>
    <ToastContainer
position="top-center"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss={false}
draggable={false}
pauseOnHover={false}
theme="light"
transition={Bounce}
/>
      </>
  );
}

export default App;
